import { useTranslation } from 'react-i18next'
import { FilterField, FilterOperator } from './filterTypes'
import { SizeFilterInput } from './filters/SizeFilterInput'
import { UserFilterInput } from './filters/UserFilterInput'
import { ChoiceFilterInput } from './filters/ChoiceFilterInput'
import { TextFilterInput } from './filters/TextFilterInput'

interface FilterValueInputProps {
  field: FilterField
  operator: FilterOperator
  onSubmit: (value: string, valueLabel: string) => void
}

export function FilterValueInput({ field, operator, onSubmit }: FilterValueInputProps) {
  const { t } = useTranslation()

  return (
    <div className="px-3 py-2">
      <div className="text-xs text-base-content/50 mb-2">
        {field.key === 'type' ? field.label : `${field.label} ${t(`fileExplorer.filters.operators.${operator}`)}`}
      </div>

      {field.type === 'size' ? (
        <SizeFilterInput onSubmit={onSubmit} />
      ) : field.type === 'user' ? (
        <UserFilterInput fieldKey={field.key} onSubmit={onSubmit} />
      ) : field.type === 'choice' && field.choices ? (
        <ChoiceFilterInput field={field} onSubmit={onSubmit} />
      ) : (
        <TextFilterInput field={field} onSubmit={onSubmit} />
      )}
    </div>
  )
}
